import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import Debug from 'debug';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { LocalStorageService } from '../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';
import { ComponentCanDeactivate } from '../interfaces/ComponentCanDeactivate.interface';
const debug = Debug('aumico:project-reports-fe:CanDeactivate');

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
    constructor(private router: Router, private localStorageService: LocalStorageService) {}

    canDeactivate(
        component: ComponentCanDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        if (nextState == null) {
            throw new Error('The next state is null');
        }
        // In case session is expired and a component guarded by PendingChangesGuard is open
        if (nextState != null && nextState.url.includes('logout')) {
            return of(true);
        }

        const routerNavigation = this.router.getCurrentNavigation();
        if (routerNavigation != null && routerNavigation.extras.state != null) {
            let state = routerNavigation.extras.state;
            if (state['skipChangeDetection']) {
                return of(true);
            }
        }

        return component.canDeactivate().pipe(
            map((canDeactivate) => {
                if (!canDeactivate) {
                    return false;
                }

                if (this.isLanguageChanged(nextState.url)) {
                    return this.router.createUrlTree([this.replaceOldLanguageByNewOne(nextState.url)]);
                } else {
                    return true;
                }
            }),
            first(),
        );
    }

    private replaceOldLanguageByNewOne(urlToRedirectTo: string): string {
        const splitUrl = urlToRedirectTo.split('/');
        splitUrl[1] = this.localStorageService.getCurrentLanguage();
        const updatedUrlToRedirectTo = splitUrl.join('/');
        return updatedUrlToRedirectTo;
    }

    private isLanguageChanged(urlToRedirectTo: string): boolean {
        const splitUrl = urlToRedirectTo.split('/');
        const currentLanguage = splitUrl[1];
        const selectedLanguage = this.localStorageService.getCurrentLanguage();

        return currentLanguage !== selectedLanguage;
    }
}
